import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetStatLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_STAT_LOTTERY
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetStatLotteryAction({
                    data: data.data,
                    page: data.count,
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetStatLottery as SetGetStatLottery
}